import { Link, useLocation } from 'react-router-dom'
import { ChevronRight, Home } from 'lucide-react'
import { cn } from '../../utils'

/**
 * Breadcrumb — auto-generated from route OR accepts manual `items` prop.
 *
 * Manual usage:
 *   <Breadcrumb items={[{ label: 'Audit Policy' }, { label: 'Run Audit' }]} />
 *
 * Auto usage (reads from location + breadcrumbMap):
 *   <Breadcrumb />
 */

const breadcrumbMap = {
  // '/audit/dashboard': [{ label: 'Audit Policy' }, { label: 'Dashboard' }],
  '/audit/run':       [{ label: 'Audit Policy' }, { label: 'Run Audit'  }],
}

export default function Breadcrumb({ items }) {
  const location = useLocation()
  const crumbs   = items || breadcrumbMap[location.pathname] || []

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm text-slate-500 mb-6">
      <Link
        to="/audit/run"
        className="flex items-center gap-1 hover:text-slate-800 transition-colors"
      >
        <Home className="h-3.5 w-3.5" />
        <span>Home</span>
      </Link>
      {crumbs.map((crumb, i) => (
        <span key={i} className="flex items-center gap-1">
          <ChevronRight className="h-3.5 w-3.5 text-slate-300" />
          {crumb.to ? (
            <Link to={crumb.to} className="hover:text-slate-800 transition-colors">
              {crumb.label}
            </Link>
          ) : (
            <span
              className={cn(
                i === crumbs.length - 1
                  ? 'font-semibold text-slate-800'
                  : 'text-slate-500'
              )}
            >
              {crumb.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  )
}
